import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { AvatarComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-assistant-cell-person',
  imports: [AvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <rt-avatar
      shape="oval"
      size="small"
      [type]="avatarType()"
      [imageSrc]="avatarUrl() ?? null"
      [fullName]="name()"
      [initials]="initials() ?? ''"
    />
    <span class="name">{{ name() }}</span>
  `,
  styleUrl: './cell-person.component.less',
})
export class AssistantCellPersonComponent {
  public static readonly NgInputs = [
    <const>'name',
    <const>'avatarUrl',
    <const>'initials',
    <const>'hasAvatar',
  ];

  protected readonly avatarType = computed<'image' | 'initials'>(() =>
    this.avatarUrl() && this.hasAvatar() !== false ? 'image' : 'initials',
  );

  public readonly name = input<string>('');
  public readonly avatarUrl = input<string | null | undefined>();
  public readonly initials = input<string | null | undefined>();
  public readonly hasAvatar = input<boolean | null | undefined>();
}
